export const AGENDA_TOPIC = [
    {
        "value": "AgendaDigWell",
        "label": "Digital Wellbeing"
    },
    {
        "value": "AgendaDigLit",
        "label": "Digital Literacy"
    },
    {
        "value": "AgendaDigCiti",
        "label": "Digital Citizenship/CyberCitizenship"
    },
    {
        "value": "AgendaAILit",
        "label": "AI Literacy"
    },
    {
        "value": "AgendaChildOnlSaf",
        "label": "Child Online Safety"
    },
    {
        "value": "AgendaOnlSafe",
        "label": "Online Safety"
    },
    {
        "value": "AgendaCybersecuri",
        "label": "Cyber Security"
    },
    {
        "value": "AgendaCreative",
        "label": "Creativity/Design"
    }
];

export const AGENDA_TOPIC_MAP = {
    "AgendaDigWell": {
        "label": "Digital Wellbeing"
    },
    "AgendaDigLit":{
        "label":"Digital Literacy"
    },
    "AgendaDigCiti": {
        "label": "Digital Citizenship/CyberCitizenship"
    },
    "AgendaAILit": {
        "label": "AI Literacy"
    },
    "AgendaChildOnlSaf": {
        "label": "Child Online Safety"
    },
    "AgendaOnlSafe": {
        "label": "Online Safety"
    },
    "AgendaCybersecuri": {
        "label": "Cyber Security"
    },
    "AgendaCreative": {
        "label": "Creativity/Design"
    },

};